import { createContext } from 'react';

export const interactionContext = createContext({});
